import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useBranding() {
  const [brand, setBrand] = useState(null);
  useEffect(() => {
    const loadBrand = () => api.get("/branding").then((r) => setBrand(r.data)).catch((e) => console.warn("branding load failed", e));
    loadBrand();
    window.addEventListener("branding-updated", loadBrand);
    return () => window.removeEventListener("branding-updated", loadBrand);
  }, []);
  return brand;
}

export function useUnreadCount(pathname, intervalMs = 20000) {
  const [unread, setUnread] = useState(0);
  useEffect(() => {
    const poll = () => api.get("/chat/unread").then((r) => setUnread(r.data.unread)).catch(() => setUnread((n) => n));
    poll();
    const t = setInterval(poll, intervalMs);
    return () => clearInterval(t);
  }, [pathname, intervalMs]);
  return unread;
}
